module.exports = __webpack_public_path__ + "static/img3new-b7bb4be5854df443fe235cb53b85594f.jpg";